module.exports = __webpack_public_path__ + "img/img-3-6.be4aec4d.webp";